import * as React from "react";
const SvgChevronRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.06209 4.19483L12.8679 9.99983L7.06209 15.8057", stroke: "#111111", strokeWidth: 1.25 }));
export default SvgChevronRight;
